import React from 'react';
import {
  Router as DefaultRouter,
  Route,
  Switch,
  StaticRouter,
} from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/lib/renderRoutes';
import history from '@@/history';
import _dvaDynamic from 'dva/dynamic';

const Router = require('dva/router').routerRedux.ConnectedRouter;

const routes = [
  {
    path: '/',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "layouts__index" */ '../../layouts/index.tsx'),
        })
      : require('../../layouts/index.tsx').default,
    routes: [
      {
        path: '/commission/external',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__commission__external__index" */ '../commission/external/index.tsx'),
            })
          : require('../commission/external/index.tsx').default,
        title: '外部商家佣金管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '外部商家佣金管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/commission/self/extra',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__commission__self__extra__index" */ '../commission/self/extra/index.tsx'),
            })
          : require('../commission/self/extra/index.tsx').default,
        title: 'GB额外佣金模型',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'GB额外佣金模型',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/commission/self/extra/:report',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__commission__self__extra___report" */ '../commission/self/extra/$report.js'),
            })
          : require('../commission/self/extra/$report.js').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/commission/self/module',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__commission__self__module__index" */ '../commission/self/module/index.tsx'),
            })
          : require('../commission/self/module/index.tsx').default,
        title: '分组佣金模型',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '分组佣金模型',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/commission/self/sku',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__commission__self__sku__index" */ '../commission/self/sku/index.tsx'),
            })
          : require('../commission/self/sku/index.tsx').default,
        title: 'SKU佣金模型',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'SKU佣金模型',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/commission/third/category',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__commission__third__category__index" */ '../commission/third/category/index.tsx'),
            })
          : require('../commission/third/category/index.tsx').default,
        title: '商品类目佣金',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商品类目佣金',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/commission/third/default',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__commission__third__default__index" */ '../commission/third/default/index.tsx'),
            })
          : require('../commission/third/default/index.tsx').default,
        title: '默认类目佣金',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '默认类目佣金',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/commission/third/main',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__commission__third__main__index" */ '../commission/third/main/index.tsx'),
            })
          : require('../commission/third/main/index.tsx').default,
        title: '主推商品佣金',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '主推商品佣金',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/coupon/list',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__coupon__list__index" */ '../coupon/list/index.tsx'),
            })
          : require('../coupon/list/index.tsx').default,
        title: '独家coupon管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '独家coupon管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/coupon/logFile',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__coupon__logFile__index" */ '../coupon/logFile/index.tsx'),
            })
          : require('../coupon/logFile/index.tsx').default,
        title: '独家coupon绑定日志',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '独家coupon绑定日志',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/coupon/resource',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__coupon__resource__index" */ '../coupon/resource/index.tsx'),
            })
          : require('../coupon/resource/index.tsx').default,
        title: '独家coupon资源管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '独家coupon资源管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/finance/leagueFinance/record/detail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__finance__leagueFinance__record__detail" */ '../finance/leagueFinance/record/detail.tsx'),
            })
          : require('../finance/leagueFinance/record/detail.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/finance/leagueFinance/record',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__finance__leagueFinance__record__index" */ '../finance/leagueFinance/record/index.tsx'),
            })
          : require('../finance/leagueFinance/record/index.tsx').default,
        title: '联盟客收支记录',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '联盟客收支记录',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/finance/leagueFinance/withdraw/detail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__finance__leagueFinance__withdraw__detail" */ '../finance/leagueFinance/withdraw/detail.tsx'),
            })
          : require('../finance/leagueFinance/withdraw/detail.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/finance/leagueFinance/withdraw',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__finance__leagueFinance__withdraw__index" */ '../finance/leagueFinance/withdraw/index.tsx'),
            })
          : require('../finance/leagueFinance/withdraw/index.tsx').default,
        title: '联盟客提现审核',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '联盟客提现审核',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/finance/merchantFinance/recharge',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__finance__merchantFinance__recharge__index" */ '../finance/merchantFinance/recharge/index.tsx'),
            })
          : require('../finance/merchantFinance/recharge/index.tsx').default,
        title: '商家充值管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商家充值管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/finance/merchantFinance/record/detail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__finance__merchantFinance__record__detail" */ '../finance/merchantFinance/record/detail.tsx'),
            })
          : require('../finance/merchantFinance/record/detail.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/finance/merchantFinance/record',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__finance__merchantFinance__record__index" */ '../finance/merchantFinance/record/index.tsx'),
            })
          : require('../finance/merchantFinance/record/index.tsx').default,
        title: '商家收支记录',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商家收支记录',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__index" */ '../index.tsx'),
            })
          : require('../index.tsx').default,
        title: '首页',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '首页',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/leagueManage/api',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__leagueManage__api__index" */ '../leagueManage/api/index.tsx'),
            })
          : require('../leagueManage/api/index.tsx').default,
        title: 'api申请',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'api申请',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/leagueManage/celebrity',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__leagueManage__celebrity__index" */ '../leagueManage/celebrity/index.tsx'),
            })
          : require('../leagueManage/celebrity/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/leagueManage/group',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__leagueManage__group__index" */ '../leagueManage/group/index.tsx'),
            })
          : require('../leagueManage/group/index.tsx').default,
        title: '联盟客分组',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '联盟客分组',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/leagueManage/league',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__leagueManage__league__index" */ '../leagueManage/league/index.tsx'),
            })
          : require('../leagueManage/league/index.tsx').default,
        title: '联盟客管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '联盟客管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/leagueManage/logout',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__leagueManage__logout__index" */ '../leagueManage/logout/index.tsx'),
            })
          : require('../leagueManage/logout/index.tsx').default,
        title: '待注销联盟客',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '待注销联盟客',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/leagueManage/resource/detail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__leagueManage__resource__detail" */ '../leagueManage/resource/detail.tsx'),
            })
          : require('../leagueManage/resource/detail.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/leagueManage/resource',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__leagueManage__resource__index" */ '../leagueManage/resource/index.tsx'),
            })
          : require('../leagueManage/resource/index.tsx').default,
        title: '联盟客资源管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '联盟客资源管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/leagueManage/singout',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__leagueManage__singout__index" */ '../leagueManage/singout/index.tsx'),
            })
          : require('../leagueManage/singout/index.tsx').default,
        title: '联盟客注销申请',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '联盟客注销申请',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/leagueManage/social',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__leagueManage__social__index" */ '../leagueManage/social/index.tsx'),
            })
          : require('../leagueManage/social/index.tsx').default,
        title: '社交平台用户列表',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '社交平台用户列表',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/leagueManage/tag',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__leagueManage__tag__index" */ '../leagueManage/tag/index.tsx'),
            })
          : require('../leagueManage/tag/index.tsx').default,
        title: '联盟客标签管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '联盟客标签管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/award',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__award__index" */ '../marketing/award/index.tsx'),
            })
          : require('../marketing/award/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/give/applyPrize',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__give__applyPrize" */ '../marketing/give/applyPrize.tsx'),
            })
          : require('../marketing/give/applyPrize.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/give',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__give__index" */ '../marketing/give/index.tsx'),
            })
          : require('../marketing/give/index.tsx').default,
        title: '手工发奖',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '手工发奖',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/incentive/add/form_activity_material',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__incentive__add__form_activity_material" */ '../marketing/incentive/add/form_activity_material.tsx'),
            })
          : require('../marketing/incentive/add/form_activity_material.tsx')
              .default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/incentive/add/form_activity_rule',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__incentive__add__form_activity_rule" */ '../marketing/incentive/add/form_activity_rule.tsx'),
            })
          : require('../marketing/incentive/add/form_activity_rule.tsx')
              .default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/incentive/add/form_base_info',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__incentive__add__form_base_info" */ '../marketing/incentive/add/form_base_info.tsx'),
            })
          : require('../marketing/incentive/add/form_base_info.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/incentive/add',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__incentive__add__index" */ '../marketing/incentive/add/index.tsx'),
            })
          : require('../marketing/incentive/add/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/incentive/detail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__incentive__detail" */ '../marketing/incentive/detail.tsx'),
            })
          : require('../marketing/incentive/detail.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/incentive',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__incentive__index" */ '../marketing/incentive/index.tsx'),
            })
          : require('../marketing/incentive/index.tsx').default,
        title: '激励活动',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '激励活动',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/incentive/reportChart',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__incentive__reportChart" */ '../marketing/incentive/reportChart.tsx'),
            })
          : require('../marketing/incentive/reportChart.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/invitecode',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__invitecode__index" */ '../marketing/invitecode/index.tsx'),
            })
          : require('../marketing/invitecode/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/list/addActivity',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__list__addActivity" */ '../marketing/list/addActivity.tsx'),
            })
          : require('../marketing/list/addActivity.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/list',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__list__index" */ '../marketing/list/index.tsx'),
            })
          : require('../marketing/list/index.tsx').default,
        title: '手工活动列表',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '手工活动列表',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/register',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__register__index" */ '../marketing/register/index.tsx'),
            })
          : require('../marketing/register/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/tiktok/auditList/auditModal',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__tiktok__auditList__auditModal" */ '../marketing/tiktok/auditList/auditModal.tsx'),
            })
          : require('../marketing/tiktok/auditList/auditModal.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/tiktok/auditList/auditRejectModal',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__tiktok__auditList__auditRejectModal" */ '../marketing/tiktok/auditList/auditRejectModal.tsx'),
            })
          : require('../marketing/tiktok/auditList/auditRejectModal.tsx')
              .default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/tiktok/auditList',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__tiktok__auditList__index" */ '../marketing/tiktok/auditList/index.tsx'),
            })
          : require('../marketing/tiktok/auditList/index.tsx').default,
        title: 'Tiktok审核列表',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'Tiktok审核列表',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/tiktok/authList/index copy',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__tiktok__authList__index copy" */ '../marketing/tiktok/authList/index copy.tsx'),
            })
          : require('../marketing/tiktok/authList/index copy.tsx').default,
        title: '列表模板',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '列表模板',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/tiktok/authList',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__tiktok__authList__index" */ '../marketing/tiktok/authList/index.tsx'),
            })
          : require('../marketing/tiktok/authList/index.tsx').default,
        title: '列表模板',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '列表模板',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/marketing/vip',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__marketing__vip__index" */ '../marketing/vip/index.tsx'),
            })
          : require('../marketing/vip/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/material/bannerCategory',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__material__bannerCategory__index" */ '../material/bannerCategory/index.tsx'),
            })
          : require('../material/bannerCategory/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/material/bannerMaterial',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__material__bannerMaterial__index" */ '../material/bannerMaterial/index.tsx'),
            })
          : require('../material/bannerMaterial/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/material/bannerTopic',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__material__bannerTopic__index" */ '../material/bannerTopic/index.tsx'),
            })
          : require('../material/bannerTopic/index.tsx').default,
        title: 'banner专题管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'banner专题管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/material/couponCategory',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__material__couponCategory__index" */ '../material/couponCategory/index.tsx'),
            })
          : require('../material/couponCategory/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/material/couponMaterial',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__material__couponMaterial__index" */ '../material/couponMaterial/index.tsx'),
            })
          : require('../material/couponMaterial/index.tsx').default,
        title: 'coupon素材管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'coupon素材管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/material/goodsCategory',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__material__goodsCategory__index" */ '../material/goodsCategory/index.tsx'),
            })
          : require('../material/goodsCategory/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/material/goodsMaterial',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__material__goodsMaterial__index" */ '../material/goodsMaterial/index.tsx'),
            })
          : require('../material/goodsMaterial/index.tsx').default,
        title: '商品素材管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商品素材管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/material/materialRecommend/fileTypeEdit',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__material__materialRecommend__fileTypeEdit" */ '../material/materialRecommend/fileTypeEdit.tsx'),
            })
          : require('../material/materialRecommend/fileTypeEdit.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/material/materialRecommend',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__material__materialRecommend__index" */ '../material/materialRecommend/index.tsx'),
            })
          : require('../material/materialRecommend/index.tsx').default,
        title: '素材文件推荐',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '素材文件推荐',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/merchantManage/domain',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__merchantManage__domain__index" */ '../merchantManage/domain/index.tsx'),
            })
          : require('../merchantManage/domain/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/merchantManage/list',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__merchantManage__list__index" */ '../merchantManage/list/index.tsx'),
            })
          : require('../merchantManage/list/index.tsx').default,
        title: '商家列表',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商家列表',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/merchantManage/permission',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__merchantManage__permission__index" */ '../merchantManage/permission/index.tsx'),
            })
          : require('../merchantManage/permission/index.tsx').default,
        title: '商家权限设置',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商家权限设置',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/merchantManage/userManage/menu',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__merchantManage__userManage__menu__index" */ '../merchantManage/userManage/menu/index.tsx'),
            })
          : require('../merchantManage/userManage/menu/index.tsx').default,
        title: '商家菜单管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商家菜单管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/merchantManage/userManage/role',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__merchantManage__userManage__role__index" */ '../merchantManage/userManage/role/index.tsx'),
            })
          : require('../merchantManage/userManage/role/index.tsx').default,
        title: '商家角色管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商家角色管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/merchantManage/userManage/user',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__merchantManage__userManage__user__index" */ '../merchantManage/userManage/user/index.tsx'),
            })
          : require('../merchantManage/userManage/user/index.tsx').default,
        title: '商家用户管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '商家用户管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/monitor/monitorList',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__monitor__monitorList__index" */ '../monitor/monitorList/index.tsx'),
            })
          : require('../monitor/monitorList/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/monitor/monitorLog',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__monitor__monitorLog__index" */ '../monitor/monitorLog/index.tsx'),
            })
          : require('../monitor/monitorLog/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/operation/adPosition',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__operation__adPosition__index" */ '../operation/adPosition/index.tsx'),
            })
          : require('../operation/adPosition/index.tsx').default,
        title: '促销氛围管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '促销氛围管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/operation/marketingEmail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__operation__marketingEmail__index" */ '../operation/marketingEmail/index.tsx'),
            })
          : require('../operation/marketingEmail/index.tsx').default,
        title: '营销邮件任务管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '营销邮件任务管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/operation/marketingEmailList',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__operation__marketingEmailList__index" */ '../operation/marketingEmailList/index.tsx'),
            })
          : require('../operation/marketingEmailList/index.tsx').default,
        title: '营销邮件发送记录',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '营销邮件发送记录',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/operation/orderNotSettled',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__operation__orderNotSettled__index" */ '../operation/orderNotSettled/index.tsx'),
            })
          : require('../operation/orderNotSettled/index.tsx').default,
        title: '导入订单不结佣',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '导入订单不结佣',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/operation/platformEmail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__operation__platformEmail__index" */ '../operation/platformEmail/index.tsx'),
            })
          : require('../operation/platformEmail/index.tsx').default,
        title: '邮件模板管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '邮件模板管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/operation/postback',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__operation__postback__index" */ '../operation/postback/index.tsx'),
            })
          : require('../operation/postback/index.tsx').default,
        title: 'postback管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'postback管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/operation/postbackRes',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__operation__postbackRes__index" */ '../operation/postbackRes/index.tsx'),
            })
          : require('../operation/postbackRes/index.tsx').default,
        title: 'postback结果查询',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'postback结果查询',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/operation/reviewApply',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__operation__reviewApply__index" */ '../operation/reviewApply/index.tsx'),
            })
          : require('../operation/reviewApply/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/operation/reviewEvent',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__operation__reviewEvent__index" */ '../operation/reviewEvent/index.tsx'),
            })
          : require('../operation/reviewEvent/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/operation/reviewGoods',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__operation__reviewGoods__index" */ '../operation/reviewGoods/index.tsx'),
            })
          : require('../operation/reviewGoods/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/operation/taskApply',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__operation__taskApply__index" */ '../operation/taskApply/index.tsx'),
            })
          : require('../operation/taskApply/index.tsx').default,
        title: 'FG任务申请',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'FG任务申请',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/operation/taskManage',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__operation__taskManage__index" */ '../operation/taskManage/index.tsx'),
            })
          : require('../operation/taskManage/index.tsx').default,
        title: 'FG任务管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'FG任务管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/others/404',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__others__404" */ '../others/404.tsx'),
            })
          : require('../others/404.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/others/login',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__others__login" */ '../others/login.tsx'),
            })
          : require('../others/login.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/report/bing/detail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__report__bing__detail__index" */ '../report/bing/detail/index.tsx'),
            })
          : require('../report/bing/detail/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/report/bing/statistics',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__report__bing__statistics__index" */ '../report/bing/statistics/index.tsx'),
            })
          : require('../report/bing/statistics/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/report/salesReport/category',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__report__salesReport__category__index" */ '../report/salesReport/category/index.tsx'),
            })
          : require('../report/salesReport/category/index.tsx').default,
        title: '类目销售统计',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '类目销售统计',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/report/salesReport/league',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__report__salesReport__league__index" */ '../report/salesReport/league/index.tsx'),
            })
          : require('../report/salesReport/league/index.tsx').default,
        title: '联盟客销售统计',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '联盟客销售统计',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/report/salesReport/link/LinkDetail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__report__salesReport__link__LinkDetail" */ '../report/salesReport/link/LinkDetail.tsx'),
            })
          : require('../report/salesReport/link/LinkDetail.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/report/salesReport/link',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__report__salesReport__link__index" */ '../report/salesReport/link/index.tsx'),
            })
          : require('../report/salesReport/link/index.tsx').default,
        title: '追踪链接明细',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '追踪链接明细',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/report/salesReport/merchant',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__report__salesReport__merchant__index" */ '../report/salesReport/merchant/index.tsx'),
            })
          : require('../report/salesReport/merchant/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/report/salesReport/month',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__report__salesReport__month__index" */ '../report/salesReport/month/index.tsx'),
            })
          : require('../report/salesReport/month/index.tsx').default,
        title: '月报表',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '月报表',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/report/salesReport/order/detail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__report__salesReport__order__detail" */ '../report/salesReport/order/detail.tsx'),
            })
          : require('../report/salesReport/order/detail.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/report/salesReport/order',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__report__salesReport__order__index" */ '../report/salesReport/order/index.tsx'),
            })
          : require('../report/salesReport/order/index.tsx').default,
        title: '联盟客订单明细',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '联盟客订单明细',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/report/salesReport/showcase/detail',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__report__salesReport__showcase__detail" */ '../report/salesReport/showcase/detail.tsx'),
            })
          : require('../report/salesReport/showcase/detail.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/report/salesReport/showcase',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__report__salesReport__showcase__index" */ '../report/salesReport/showcase/index.tsx'),
            })
          : require('../report/salesReport/showcase/index.tsx').default,
        title: '橱窗广告报表',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '橱窗广告报表',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/report/salesReport/skuStatistics',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__report__salesReport__skuStatistics__index" */ '../report/salesReport/skuStatistics/index.tsx'),
            })
          : require('../report/salesReport/skuStatistics/index.tsx').default,
        title: 'SKU销售统计',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'SKU销售统计',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/articleManage/add',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__articleManage__add__index" */ '../systemManage/articleManage/add/index.tsx'),
            })
          : require('../systemManage/articleManage/add/index.tsx').default,
        _title: 'AFF_FE_backend',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/articleManage/blogManage/add',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__articleManage__blogManage__add__index" */ '../systemManage/articleManage/blogManage/add/index.tsx'),
            })
          : require('../systemManage/articleManage/blogManage/add/index.tsx')
              .default,
        title: '添加文章',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '添加文章',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/articleManage/blogManage/author',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__articleManage__blogManage__author__index" */ '../systemManage/articleManage/blogManage/author/index.tsx'),
            })
          : require('../systemManage/articleManage/blogManage/author/index.tsx')
              .default,
        title: 'Blog作者管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'Blog作者管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/articleManage/blogManage/category',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__articleManage__blogManage__category__index" */ '../systemManage/articleManage/blogManage/category/index.tsx'),
            })
          : require('../systemManage/articleManage/blogManage/category/index.tsx')
              .default,
        title: 'Blog分类管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'Blog分类管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/articleManage/blogManage/list',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__articleManage__blogManage__list__index" */ '../systemManage/articleManage/blogManage/list/index.tsx'),
            })
          : require('../systemManage/articleManage/blogManage/list/index.tsx')
              .default,
        title: 'Blog列表',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'Blog列表',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/articleManage/bulletin',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__articleManage__bulletin__index" */ '../systemManage/articleManage/bulletin/index.tsx'),
            })
          : require('../systemManage/articleManage/bulletin/index.tsx').default,
        title: '信息公告',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '信息公告',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/articleManage/category',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__articleManage__category__index" */ '../systemManage/articleManage/category/index.tsx'),
            })
          : require('../systemManage/articleManage/category/index.tsx').default,
        title: 'FAQ分类模块管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'FAQ分类模块管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/articleManage/faq',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__articleManage__faq__index" */ '../systemManage/articleManage/faq/index.tsx'),
            })
          : require('../systemManage/articleManage/faq/index.tsx').default,
        title: 'FAQ管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: 'FAQ管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/articleManage/message',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__articleManage__message__index" */ '../systemManage/articleManage/message/index.tsx'),
            })
          : require('../systemManage/articleManage/message/index.tsx').default,
        title: '会员消息',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '会员消息',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/articleManage/preview',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__articleManage__preview__index" */ '../systemManage/articleManage/preview/index.tsx'),
            })
          : require('../systemManage/articleManage/preview/index.tsx').default,
        title: '预览',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '预览',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/articleManage/protocol',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__articleManage__protocol__index" */ '../systemManage/articleManage/protocol/index.tsx'),
            })
          : require('../systemManage/articleManage/protocol/index.tsx').default,
        title: '联盟营销服务协议',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '联盟营销服务协议',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/systemUserManage/menu',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__systemUserManage__menu__index" */ '../systemManage/systemUserManage/menu/index.tsx'),
            })
          : require('../systemManage/systemUserManage/menu/index.tsx').default,
        title: '后台菜单管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '后台菜单管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/systemUserManage/permission',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__systemUserManage__permission__index" */ '../systemManage/systemUserManage/permission/index.tsx'),
            })
          : require('../systemManage/systemUserManage/permission/index.tsx')
              .default,
        title: '后台权限设置',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '后台权限设置',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/systemUserManage/role',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__systemUserManage__role__index" */ '../systemManage/systemUserManage/role/index.tsx'),
            })
          : require('../systemManage/systemUserManage/role/index.tsx').default,
        title: '后台角色管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '后台角色管理',
        _title_default: 'AFF_FE_backend',
      },
      {
        path: '/systemManage/systemUserManage/user',
        exact: true,
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__systemManage__systemUserManage__user__index" */ '../systemManage/systemUserManage/user/index.tsx'),
            })
          : require('../systemManage/systemUserManage/user/index.tsx').default,
        title: '后台用户管理',
        Routes: [require('./TitleWrapper.jsx').default],
        _title: '后台用户管理',
        _title_default: 'AFF_FE_backend',
      },
    ],
    _title: 'AFF_FE_backend',
    _title_default: 'AFF_FE_backend',
  },
];
window.g_routes = routes;
const plugins = require('umi/_runtimePlugin');
plugins.applyForEach('patchRoutes', { initialValue: routes });

export { routes };

export default class RouterWrapper extends React.Component {
  unListen() {}

  constructor(props) {
    super(props);

    // route change handler
    function routeChangeHandler(location, action) {
      plugins.applyForEach('onRouteChange', {
        initialValue: {
          routes,
          location,
          action,
        },
      });
    }
    this.unListen = history.listen(routeChangeHandler);
    // dva 中 history.listen 会初始执行一次
    // 这里排除掉 dva 的场景，可以避免 onRouteChange 在启用 dva 后的初始加载时被多执行一次
    const isDva =
      history.listen
        .toString()
        .indexOf('callback(history.location, history.action)') > -1;
    if (!isDva) {
      routeChangeHandler(history.location);
    }
  }

  componentWillUnmount() {
    this.unListen();
  }

  render() {
    const props = this.props || {};
    return <Router history={history}>{renderRoutes(routes, props)}</Router>;
  }
}
